import {  FETCH_TASK, FETCH_TASKS } from "../Dispatchers";

const initialState = {
    task: {},
    tasks:[]
}
export function TaskReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_TASKS:
            return {
                ...state, tasks: action.payload
            }
        case FETCH_TASK:
            return {
                ...state, task: action.payload
            }

        default:
            break;
    }
    return state;
}